import parseOptions, {
  CookieConsentOptions,
  CookieSettingsOptions,
} from './parseOptions'

let cookieSettingsOptions: CookieSettingsOptions,
  cookieConsentOptions: CookieConsentOptions

function getOptions() {
  const options = parseOptions()
  if (!options) throw new Error(`Cant' parse CookieConsent options`)
  const { cookieConsentOptions: cco, cookieSettingsOptions: cso } = options
  cookieSettingsOptions = cso
  cookieConsentOptions = cco
}

export function getCookieSettingsOptions() {
  if (cookieSettingsOptions) return cookieSettingsOptions

  getOptions()
  return cookieSettingsOptions
}

export function getCookieConsentOptions() {
  if (cookieConsentOptions) return cookieConsentOptions

  getOptions()
  return cookieConsentOptions
}
